import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useIAConversationsStore, IAConversation } from '../../../../Stores/IAConversationsStore';
import { useAuthStore } from '../../../../Stores/AuthStore';

const IAConversationsListPage: React.FC = () => {
  const { savId } = useParams();
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const gestionnaireId = user?.uuid ?? null;
  const sid = savId ? Number(savId) : null;
  const conversations = useIAConversationsStore((state) =>
    sid && gestionnaireId ? state.getConversationsBySav(sid, gestionnaireId) : []
  );
  const addConversation = useIAConversationsStore((state) => state.addConversation);

  const handleNewConversation = () => {
    if (sid && gestionnaireId) {
      const newId = addConversation(sid, gestionnaireId);
      navigate(`/sav/${sid}/ia/${newId}`);
    }
  };

  const handleSelectConversation = (convId: string) => {
    if (sid) {
      navigate(`/sav/${sid}/ia/${convId}`);
    }
  };

  return (
    <div className="tw-max-w-2xl tw-mx-auto tw-py-8 tw-px-4">
      <h2 className="tw-text-2xl tw-font-bold tw-mb-6 tw-text-center">Chat IA SAV</h2>
      <div className="tw-flex tw-justify-between tw-items-center tw-mb-4">
        <h3 className="tw-text-lg tw-font-semibold">Conversations</h3>
        <button
          className="tw-bg-blue-600 tw-text-white tw-px-4 tw-py-2 tw-rounded-lg tw-shadow-sm tw-font-medium hover:tw-bg-blue-700 tw-transition"
          onClick={handleNewConversation}
          disabled={!gestionnaireId}
        >
          Nouvelle conversation
        </button>
      </div>
      <ul className="tw-space-y-3">
        {conversations.length === 0 && (
          <li className="tw-text-gray-500 tw-italic">Aucune conversation pour ce SAV.</li>
        )}
        {conversations.map((conv: IAConversation) => (
          <li
            key={conv.id}
            className="tw-cursor-pointer tw-bg-white tw-rounded-lg tw-shadow tw-p-4 tw-flex tw-justify-between tw-items-center hover:tw-shadow-md tw-transition"
            onClick={() => handleSelectConversation(conv.id)}
          >
            <div>
              <div className="tw-font-semibold tw-text-gray-800 tw-text-base">{conv.title}</div>
              <div className="tw-text-xs tw-text-gray-400">Créée le {new Date(conv.createdAt).toLocaleString()}</div>
            </div>
            <span className="tw-text-xs tw-text-gray-500">{conv.messages.length} messages</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default IAConversationsListPage;